
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/taxonomy",
      function () {
        return require("private-next-pages/taxonomy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/taxonomy"])
      });
    }
  